import React from 'react';

const NotFoundScreen = () => {
    return ( <h1>
        Not Found
    </h1> );
}
 
export default NotFoundScreen;